import React, { useState } from "react";

import { Container, Grid, TextField, Button } from "@material-ui/core";
import Label from "../../../components/Label";
import { Content } from "./styles";

import AccountCircle from "@material-ui/icons/AccountCircle";
import EmailIcon from "@material-ui/icons/Email";
import LockIcon from "@material-ui/icons/Lock";

import Enroll from "../../../services/enroll";
import { config } from "../../../config";

const Register = (props) => {
    const [values, setValues] = useState({
        name: "",
        email: "",
        password: "",
        profile_id: config.ADMIN_PROFILE_ID,
    });
    const [error, setError] = useState(null);

    function onChange(event) {
        const { value, name } = event.target;
        setValues({ ...values, [name]: value });
    }

    function onSubmit(event) {
        event.preventDefault();
        Enroll.create(values)
            .then((resp) => {
                if (!!resp.response) {
                    console.log(resp.response.data.error);
                    setError(resp.response.data.error);
                } else {
                    console.log(resp.status);
                    window.location.reload();
                }
            })
            .catch(function (error) {
                console.log(error);
                setError(error);
            });
    }

    return (
        <Container component="main" maxWidth="sm">
            <Content>
                <Label size="medium" color="dark" align="center">
                    Novo Usuário
                </Label>
                <form onSubmit={onSubmit}>
                    <div>
                        <Grid container spacing={1} alignItems="flex-end">
                            <Grid item>
                                <AccountCircle />
                            </Grid>
                            <Grid item>
                                <TextField
                                    label="Nome Completo"
                                    id="name"
                                    type="text"
                                    name="name"
                                    onChange={onChange}
                                    value={values.name}
                                />
                            </Grid>
                        </Grid>
                    </div>
                    <div>
                        <Grid container spacing={1} alignItems="flex-end">
                            <Grid item>
                                <EmailIcon />
                            </Grid>
                            <Grid item>
                                <TextField
                                    label="E-mail"
                                    id="email"
                                    type="email"
                                    name="email"
                                    onChange={onChange}
                                    value={values.email}
                                />
                            </Grid>
                        </Grid>
                    </div>
                    <div>
                        <Grid container spacing={1} alignItems="flex-end">
                            <Grid item>
                                <LockIcon />
                            </Grid>
                            <Grid item>
                                <TextField
                                    label="Senha"
                                    id="password"
                                    type="password"
                                    name="password"
                                    onChange={onChange}
                                    value={values.password}
                                />
                            </Grid>
                        </Grid>
                    </div>
                    <div className="content_button">{error && <div className="user-login__error">{error}</div>}</div>
                    <div className="content_button">
                        <Grid container spacing={1}>
                            <Grid item>
                                <Button
                                    className="button"
                                    variant="contained"
                                    color="primary"
                                    disableElevation
                                    onClick={() => props.close()}
                                >
                                    Cancelar
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    className="button"
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    disableElevation
                                >
                                    Criar
                                </Button>
                            </Grid>
                        </Grid>
                    </div>
                </form>
            </Content>
        </Container>
    );
};

export default Register;
